import {
  base_contentSelected,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: 100%;
  flex: 1;
  border: none;
  background-color: transparent;
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
  ${font_md};

  &:disabled {
    cursor: not-allowed;
  }

  &.medium {
    padding: ${spacing(4)} 0;
  }

  &.small {
    padding: ${spacing(2)} 0;
  }

  &::placeholder {
    color: ${text_colorTextSecondary};
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* Autofill styling - ensure input background matches container */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px ${base_contentSelected} inset;
  }
`
